// extracted by mini-css-extract-plugin
export default {"leftContent":"e3mnTW","title":"bgpR_Z","rightContent":"ftmisZ","divider":"bv0NYb"};